<template>
    <div class="v-counter" :class="`v-counter_${size}`">
        <svg
            @click="() => {
                if (value > min) {
                    $emit('update:value', value - 1)
                }
            }"
            :width="comWidth" :height="comHeight" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" width="30" height="30" rx="15" fill="#D5D6FF"/>
            <path
                d="M19.5002 15.6654H11.5002C11.3234 15.6654 11.1538 15.5951 11.0288 15.4701C10.9037 15.3451 10.8335 15.1755 10.8335 14.9987C10.8335 14.8219 10.9037 14.6523 11.0288 14.5273C11.1538 14.4023 11.3234 14.332 11.5002 14.332H19.5002C19.677 14.332 19.8465 14.4023 19.9716 14.5273C20.0966 14.6523 20.1668 14.8219 20.1668 14.9987C20.1668 15.1755 20.0966 15.3451 19.9716 15.4701C19.8465 15.5951 19.677 15.6654 19.5002 15.6654Z"
                fill="black"/>
        </svg>
        <div class="v-counter__value">
            <span>{{ value }}</span>
        </div>
        <svg
            @click="() => {
                if (value < max) {
                    $emit('update:value', value + 1)
                }
            }"
            :width="comWidth" :height="comHeight" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" width="30" height="30" rx="15" fill="#D5D6FF"/>
            <path
                d="M10.4727 14.7695C10.4727 14.5234 10.5586 14.3145 10.7305 14.1426C10.9062 13.9668 11.1172 13.8789 11.3633 13.8789H14.6152V10.6328C14.6152 10.3867 14.7012 10.1777 14.873 10.0059C15.0449 9.83008 15.2539 9.74219 15.5 9.74219C15.7461 9.74219 15.9551 9.83008 16.127 10.0059C16.3027 10.1777 16.3906 10.3867 16.3906 10.6328V13.8789H19.6426C19.8848 13.8789 20.0918 13.9668 20.2637 14.1426C20.4395 14.3145 20.5273 14.5234 20.5273 14.7695C20.5273 15.0156 20.4395 15.2266 20.2637 15.4023C20.0918 15.5742 19.8848 15.6602 19.6426 15.6602H16.3906V18.9121C16.3906 19.1543 16.3027 19.3613 16.127 19.5332C15.9551 19.709 15.7461 19.7969 15.5 19.7969C15.2539 19.7969 15.0449 19.709 14.873 19.5332C14.7012 19.3613 14.6152 19.1543 14.6152 18.9121V15.6602H11.3633C11.1172 15.6602 10.9062 15.5742 10.7305 15.4023C10.5586 15.2266 10.4727 15.0156 10.4727 14.7695Z"
                fill="black"/>
        </svg>
    </div>
</template>

<script>
export default {
    name: "VItemCounter",
    props: {
        value: {type: Number, default: 1},
        min: {type: Number, default: 1},
        max: {type: Number, default: 100},
        size: {
            type: String,
            default: 'medium',
            validator(value) {
                return ['small', 'medium'].includes(value);
            }
    }
    },
    emits: ['update:value'],
    computed: {
        comWidth() {
            switch (this.size) {
                case 'small':
                    return 26;
                case 'medium':
                default:
                    return 31;
            }
        },
        comHeight() {
            switch (this.size) {
                case 'small':
                    return 26;
                case 'medium':
                default:
                    return 30;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "/src/scss/assets/variables";

.v-counter {
    display: flex;
    align-items: center;
    gap: 10px;

    &__value {
        width: 22px;
        display: flex;
        align-items: center;
        justify-content: center;

        & > span {
            font: {
                weight: 700;
                size: 20px;
            }
            letter-spacing: -1px;
            color: $color_black;
        }
    }

    &_small span {
        font: {
            size: 16px;
        }
    }

    > svg {
        cursor: pointer;
    }
}
</style>
